import React from 'react';
import '../NotesModal/NotesModal.css';
import './DelaiResolutionParametrageModal.css';

const DelaiResolutionParametrageModal = ({ stat, isOpen, onClose }) => {
  console.log("🚀 ~ DelaiResolutionParametrageModal ~ stat:", stat)
  if (!isOpen) return null;

  // Default stat shape: { parametrage: "16:54:58", it: "18:21:25", dev: "15:09:15" }
  const safeStat = stat || { parametrage: '--', it: '--', dev: '--' };

  // Convert "HH:MM:SS" to total seconds (for comparison / bar width)
  const toSeconds = (time) => {
    if (!time || typeof time !== 'string' || !time.includes(':')) return 0;
    const [h, m, s] = time.split(':').map((n) => parseInt(n, 10) || 0);
    return h * 3600 + m * 60 + s;
  };

  // Format "HH:MM:SS" -> "16h 54m"
  const formatDuration = (time) => {
    if (!time || typeof time !== 'string' || !time.includes(':')) return '--';
    const [h, m,s] = time.split(':');
    return `${parseInt(h, 10)}h ${parseInt(m, 10)}m ${parseInt(s, 10)}s`;
  };

  const rows = [
    {
      key: 'parametrage',
      label: 'Paramétrage',
      value: safeStat.parametrage,
      seconds: toSeconds(safeStat.parametrage),
      color: '#8B5CF6', // purple
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
      ),
    },
    {
      key: 'it',
      label: 'IT',
      value: safeStat.it,
      seconds: toSeconds(safeStat.it),
      color: '#3B82F6', // blue
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
          <line x1="8" y1="21" x2="16" y2="21"></line>
          <line x1="12" y1="17" x2="12" y2="21"></line>
        </svg>
      ),
    },
    {
      key: 'dev',
      label: 'Dev',
      value: safeStat.dev,
      seconds: toSeconds(safeStat.dev),
      color: '#10B981', // green
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 18 22 12 16 6"></polyline>
          <polyline points="8 6 2 12 8 18"></polyline>
        </svg>
      ),
    },
  ];

  // Max for bar scaling
  const maxSeconds = Math.max(...rows.map((r) => r.seconds), 1);

  // Total time (sum of all three) for the summary header
  const totalSeconds = rows.reduce((sum, r) => sum + r.seconds, 0);
  const totalHours = Math.floor(totalSeconds / 3600);
  const totalMinutes = Math.floor((totalSeconds % 3600) / 60);

  const ClockIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  );

  const CloseIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">Délai de résolution (paramétrage)</h2>
          <button className="modal-close" onClick={onClose} aria-label="Fermer">
            <CloseIcon />
          </button>
        </div>

        <div className="modal-body">
        

          <div className="ratings-breakdown">
            {rows.map((row) => {
              const percentage = (row.seconds / maxSeconds) * 100;
              return (
                <div key={row.key} className="rating-row delai-row">
                  <div className="star-label delai-label">
                    {row.icon}
                    <span className="star-number">{row.label}</span>
                  </div>

                  <div className="progress-container">
                    <div
                      className="progress-bar"
                      style={{
                        width: `${percentage}%`,
                        backgroundColor: row.color,
                      }}
                    />
                  </div>

                  <span className="rating-count delai-value">
                    {formatDuration(row.value)}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DelaiResolutionParametrageModal;